module.exports = __webpack_public_path__ + "media/images/vp/logo-26187d0ac23692c1ac561eb5cd96354b.svg";